import type { AnalyticsEntity } from './analytics.constants'
import { pushEvent } from './analytics.gtm'

const MAX_REPORTED_FIELDS = 5

export function reportInvalidFields(
  formId: AnalyticsEntity,
  fieldMeta: Partial<Record<string, { isValid: boolean }>>,
): void {
  Object.entries(fieldMeta)
    .filter(([, meta]) => meta?.isValid === false)
    .slice(0, MAX_REPORTED_FIELDS)
    .forEach(([fieldName]) =>
      pushEvent('form_validation_failed', {
        form_id: formId,
        field: fieldName.replace(/\[\d+\]/g, ''),
      }),
    )
}
